import { PersistentFormControl, PersistentFormGroup } from '@utility/persistent-forms';
import { Moment } from 'moment';
// needed to export this formgroup to separate file to avoid circular dependencies
export class MerchantDetailsFormGroup extends PersistentFormGroup<{
    transactionDate: PersistentFormControl<Moment | null>;
    merchant: PersistentFormControl<number | null>;
}> {
    constructor() {
        super({
            transactionDate: new PersistentFormControl<Moment | null>(null),
            merchant: new PersistentFormControl<number | null>(null),
        });
    }
}
